<template>
  <section :class="`section ${cssClass}`" v-if="items && items.length" :id="`uuid-${$attrs.uuid}`">
    <div class="section__container section__container--full-small">
      <filters-bar :class="{'promo-filters' : listingType === 'promotion'}"
                   :filters="filters" v-if="filters && !filters.hideFilters"
                   :showPromoLabels="listingType === 'promotion'"
      />
      <div :class="classes">
        <div class="listing-header" v-if="listingTitle || showNote">
          <div>
            <h2
              class="listing-header__heading text--heading-l text--heading-l--section"
              v-if="listingTitle"
            >
              {{ listingTitle }}
            </h2>
            <p class="listing-header__note" v-if="showNote">
              <msg id="common.price.tooltip.text" />
            </p>

          </div>
        </div>
        <div  v-if="sorteredItems.length > 0">
          <ul class="listing__items" :class="[listingItemsAlign, {'carousel' : listingCarousel}]">
            <!-- insert control for not place an empty listing__item  -->
            <li v-if="($config.editMode || (!item.isFuture && !item.isExpired)) && listingType !== 'promotion'"
                v-for="(item, index) in filteredItems"
                :class="[`listing__item ${item.isFeatured ? 'listing__item--2cols' : ''}`]"
                :key="index">
              <card-article
                v-bind="item"
                v-if="
                  listingType === 'articles' ||
                    (listingType === 'articlesWithFeatured' &&
                      ((index !== 6 && index !== 15) || !item.isFeatured))
                "
              />
              <card-article-featured
                v-bind="item"
                v-else-if="
                  listingType === 'articleFeatured' ||
                    (listingType === 'articlesWithFeatured' &&
                      (index === 6 || index === 15) &&
                      item.isFeatured)
                "
              />
              <card-product
                :class="{'cursor-default': disableLinks === 'linksDisabled'}"
                :item="item"
                :productCardConf="productCardConf"
                :priceFormatting="priceFormatting"
                :select="disableLinks === 'linksDisabled' ? 'linksDisabled' : ''"
                v-else
              />
            </li>
            <li v-if="($config.editMode || (!item.isFuture && !item.isExpired)) && isCardPromo"
                v-for="(item, index) in filteredItems"
                :class="[`listing__item ${item.isFeatured ? 'listing__item--2cols' : ''}`]"
                :key="index">
              <card-promotion
                  :item="item"
              />
            </li>
            <li v-if="($config.editMode || (!item.isFuture && !item.isExpired)) && isListingPromo"
                v-for="(item, index) in filteredItems"
                :class="[`listing__item ${item.isFeatured ? 'listing__item--2cols' : ''} card-promotion-small ${item.mainCategory==='aftersales' ? ' card-promotion-aftersales ' : ' card-promotion-sales '}`]"
                :key="index">
              <card-promotion-small
                  :item="item"
                  v-if="listingType === 'promotion'"
              />
            </li>
            <li v-if="($config.editMode || (!item.isFuture && !item.isExpired)) && isPlpPromo"
                v-for="(item, index) in filteredItems.slice(0, 3)"
                :class="[`listing__item ${item.isFeatured ? 'listing__item--2cols' : ''} ${cardPromotionTypeSmall ? 'card-promotion-small' : 'card-promotion'}`,`${item.mainCategory==='aftersales'?' card-promotion-aftersales ':' card-promotion-sales '}`]"
                :key="index">
              <card-promotion-small
                  :item="item"
              />
            </li>
          </ul>
          <div v-if="this.listingType === 'promotion' && this.filteredItems.length > 3 && !this.$attrs.cardPromoAlwaysSmall" class="card-promotion-small__cta-container">
            <pg-button
                :href="$attrs.promotionListLink.url"
                :color="'primary'"
                :styleType="'text'"
                :size="'medium'"
                class="card-promotion-small-cta-link"
                :analyticsData="analyticsData($attrs.promotionListLink)"
            >
              <msg id="common.promotion.card.small.cta"/>
            </pg-button>
          </div>
          <div v-if="usePagination && numItemsToShow < totalItems" class="section__container text--center">
            <button @click="calculateItemsToShow()" type="button" class="button button--outline button--medium button--primary">
              <msg id="common.cta.show-more.label" :bare="false" />
            </button>
          </div>
          <div v-if="discoverMore" class="section__container text--center">
            <pg-button class="button button--outline button--medium button--primary"
                      :href="discoverMore"
                      :styleType="'outline'"
                      :size="'small'">
              <msg id="common.cta.discover-more.label" :bare="false"/>
            </pg-button>
          </div>
        </div>

        <div v-else>
          <p class="filter-no-results">
            <msg v-if="listingType === 'promotion'" id="common.filters.no-promo-results.text" />
            <msg v-else id="common.filters.no-results.text" />
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CardProduct from "../Card-Product/Card-Product";
import CardArticle from "../Card-Article/Card-Article";
import CardArticleFeatured from "../Card-Article-Featured/Card-Article-Featured";
import CardPromotion from "../Card-Promotion/Card-Promotion";
import CardPromotionSmall from "../Card-Promotion-Small/Card-Promotion-Small";
import PgButton from "../Button/Button";
import FiltersBar from "./FiltersBar";
import AdvancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";

export default {
  name: "PgListing",
  components: {
    CardProduct,
    CardArticle,
    CardArticleFeatured,
    CardPromotion,
    CardPromotionSmall,
    PgButton,
    FiltersBar,
    AdvancedButtonWrapper
  },
  data() {
    return {
      appliedFilters: null,
      appliedSort: null,
      numItemsToShow: 0,
      totalItems: null
    };
  },
  props: {
    listingTitle: {
      type: String,
      required: false,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    listingType: {
      type: String,
      required: false
    },
    cssClass: {
      type: String,
      required: false,
      default: ""
    },
    priceNote: {
      type: Boolean,
      required: false,
      default: false
    },
    productCardConf: {
      type: Object,
      default: () => {}
    },
    priceFormatting: {
      type: Object,
      default: () => {}
    },
    filters: {
      type: Object,
      default: () => {},
      require: false
    },
    usePagination: {
      type: Boolean,
      required: false,
      default: false
    },
    disableLinks: {
      type: String,
      required: false,
      default: ""
    },
    discoverMore: {
      type: String,
      required: false,
      default: "",
    }
  },
  inheritAttrs: false,
  computed: {
    cardPromotionTypeSmall() {
      return this.filteredItems.length > 2;
    },
    isCardPromo() {
      return this.listingType === 'promotion' && this.filteredItems.length <= 2 && !this.$attrs.cardPromoAlwaysSmall
    },
    isListingPromo() {
      return this.listingType === 'promotion' && this.$attrs.cardPromoAlwaysSmall;
    },
    isPlpPromo() {
      return this.listingType === 'promotion' && this.filteredItems.length > 2 && !this.$attrs.cardPromoAlwaysSmall;
    },
    listingCarousel() {
      return this.$mq === "small" && this.listingType === 'promotion' && this.filteredItems.length > 2 && !this.$attrs.cardPromoAlwaysSmall;
    },
    classes() {
      let listingClass = "small-1-large-4";
      switch (this.listingType) {
        case "vehicle":
          listingClass = "small-1-large-4";
          break;
        case "article":
        case "articles":
          listingClass = "small-2-large-4 js-items";
          break;
        case "articlesWithFeatured":
          listingClass = "small-2-large-4-with-2cols js-items";
          break;
        case "articleFeatured":
          listingClass = "mosaic";
          break;
        case "vehicle":
        case "family":
          listingClass = "small-2-large-4";
          break;
        case "accessory":
          listingClass = "small-2-large-6";
          break;
        case "promotion":
          listingClass = "small-12-large-12";
          break;
      }
      return ["listing", "listing--" + listingClass];
    },
    showNote() {
      return this.listingType === "vehicle" && this.priceNote;
    },
    filteredItems() {
      if (this.appliedFilters) {
        const filterKeys = Object.keys(this.appliedFilters);
        return this.items.filter(item => {
          // validates all filter criteria
          return filterKeys.every(key => {
            if (typeof this.appliedFilters[key] !== "function") return true;

            return this.appliedFilters[key](item[key]);
          });

          return this.appliedFilters[key](item[key]);
        });
      } else {
        this.totalItems = this.items.length;

        return this.items;
      }
    },
    sorteredItems() {
      switch (this.appliedSort) {
        case "name-asc":
          return this.filteredItems.sort();
        case "name-desc":
          return this.filteredItems.sort().reverse();
        case "price-asc":
          return this.filteredItems.sort(function(a, b) {
            return a.price - b.price;
          });
        case "price-desc":
          return this.filteredItems.sort(function(a, b) {
            return b.price - a.price;
          });
        case "startDate-asc":
          return this.filteredItems.sort(function(a, b) {
              return this.compareItems.call(this, a, b, "startDate-asc");
          }.bind(this));
        case "startDate-desc":
          return this.filteredItems.sort(function(a, b) {
            return this.compareItems.call(this, a, b, "startDate-desc");
          }.bind(this));
        case "endDate-asc":
          return this.filteredItems.sort(function(a, b) {
            return this.compareItems.call(this, a, b, "endDate-asc");
          }.bind(this));
        case "endDate-desc":
          return this.filteredItems.sort(function(a, b) {
            return this.compareItems.call(this, a, b, "endDate-desc");
          }.bind(this));
        case "priority-desc":
          return this.filteredItems.sort(function(a, b) {
            return this.compareItems.call(this, a, b, "priority-desc");
          }.bind(this));
          case "priority-asc":
            return this.filteredItems.sort(function(a, b) {
              return this.compareItems.call(this, a, b, "priority-asc");
          }.bind(this));
          default:
          return this.filteredItems;
      }
    },
    listingItemsAlign() {
      return (this.listingType === "family" || this.listingType === "vehicle") ? " align-center" : "";
    }
  },
  methods: {
    compareItems(a, b, sortOrder) {
      // console.log(a);
      const promotionModeA = typeof a.promotionMode !== 'undefined' && a.promotionMode != null && a.promotionMode === "pqm";
      const promotionModeB = typeof b.promotionMode !== 'undefined' && b.promotionMode != null && b.promotionMode === "pqm";

      if (promotionModeA && !promotionModeB) {
        return -1;
      } else if (!promotionModeA && promotionModeB) {
        return 1;
      }

      if (typeof a.pinned !== 'undefined' && typeof b.pinned !== 'undefined') {
        if (a.pinned && !b.pinned) {
          return -1;
        } else if (!a.pinned && b.pinned) {
          return 1;
        }
      }

      const sDateA = new Date(a.startDate);
      const sDateB = new Date(b.startDate);
      const eDateA = new Date(a.endDate);
      const eDateB = new Date(b.endDate);

      let result = 0;
      switch (sortOrder) {
        case "startDate-desc":
          result = sDateB - sDateA;
          break;
        case "startDate-asc":
          result = sDateA - sDateB;
          break;
        case "endDate-desc":
          result = eDateB - eDateA;
          break;
        case "endDate-asc":
          result = eDateA - eDateB;
          break;
        case "priority-desc":
          result = b.priorityLevel - a.priorityLevel;
          break;
        case "priority-asc":
          result = a.priorityLevel - b.priorityLevel;
          break
        default:
          result = 0;
      }
      if (result === 0) {
        result = a.id - b.id;
      }
      return result;
    },
    isFeatured(index) {
      // check if is an article Featured and change the numItemsToShow value
      return this.items[index] && this.items[index].isFeatured;
    },
    calculateItemsToShow() {

      if(!this.usePagination) return;

      this.numItemsToShow += 8;
      const listing = document.querySelector('.js-items .listing__items');
      const listingItems = listing.childNodes;

      listingItems.forEach((item, index) => {

        if ((this.numItemsToShow ===  8 && this.isFeatured(index)) ||
            (this.numItemsToShow === 23 && this.isFeatured(index))) {
          this.numItemsToShow -= 1;
        }

        if (index > this.numItemsToShow - 1) {
          item.classList.add('visual-hidden');
        } else {
          item.classList.remove('visual-hidden');
        }


      })

    },
    analyticsData(el) {
      return {
        evCategory: 'call_to_action',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.$attrs.actpageFullUrl}`
      }
    }
  },

  mounted() {
    const ctx = this;
    ctx.$eventHub.on("filtersBar:filter-by", appliedFilters => {
      ctx.appliedFilters = appliedFilters;
    });

    ctx.$eventHub.on("filtersBar:sort-by", appliedSort => {
      ctx.appliedSort = appliedSort;
    });

    this.calculateItemsToShow()

  },
};
</script>

